module.exports = __webpack_public_path__ + "static/cinsa_tu_calentador_ideal_familia_cinsa-f43fd92206897f9a2458ed21183401dd.png";